/**
 * LINE QR Code API Service
 */
import apiClient from '../axios.js';

export default {
  /**
   * 查詢 QR Code 列表
   * @param {Object} params - 查詢參數
   * @returns {Promise}
   */
  async list(params = {}) {
    const response = await apiClient.get('/line/qrcode', { params });
    return response;
  },

  /**
   * 查詢 QR Code 詳情
   * @param {string} id - QR Code ID
   * @returns {Promise}
   */
  async get(id) {
    const response = await apiClient.get(`/line/qrcode/${id}`);
    return response;
  },

  /**
   * 建立 QR Code
   * @param {Object} data - QR Code 資料
   * @returns {Promise}
   */
  async create(data) {
    const response = await apiClient.post('/line/qrcode', data);
    return response;
  },

  /**
   * 更新 QR Code
   * @param {string} id - QR Code ID
   * @param {Object} data - 更新資料
   * @returns {Promise}
   */
  async update(id, data) {
    const response = await apiClient.put(`/line/qrcode/${id}`, data);
    return response;
  },

  /**
   * 刪除 QR Code
   * @param {string} id - QR Code ID
   * @returns {Promise}
   */
  async delete(id) {
    const response = await apiClient.delete(`/line/qrcode/${id}`);
    return response;
  },

  /**
   * 取得 QR Code 圖片
   * @param {string} id - QR Code ID
   * @returns {Promise}
   */
  async getImage(id) {
    const response = await apiClient.get(`/line/qrcode/${id}/image`);
    return response;
  },

  /**
   * 上傳 QR Code Logo
   * @param {string} id - QR Code ID
   * @param {File} file - 圖片文件
   * @returns {Promise}
   */
  async uploadLogo(id, file) {
    const formData = new FormData();
    formData.append('file', file);

    const response = await apiClient.post(
      `/line/qrcode/${id}/upload-logo`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    return response;
  }
};
